<template>
    <div id="step_component_wrapper"> 
        <div class="slot-content" style="text-align: center;">
            
            <div v-if="reference == 'date'">
                <datepicker v-model="date" class="col-xs-6 col-xs-offset-3" style="padding: 0px; color: black;" :full-month-name="true"
                :clear-button="true" :placeholder="$Jed.firstUpperTranslate('pick a date as validity', null)" format="dd / MM / yyyy" :language="datePickLang"></datepicker>
            </div>
            <div v-else class="input-group">
                <span class="input-group-addon" :class="{'error_highlight': !machineValid}"><i :class="$root.icons.search_btn" aria-hidden="true"></i></span>
                <input class="form-control" id="selector"  :class="{'error_highlight': !machineValid}" type="text" 
                v-model="matricola" :placeholder="machinePlaceholder[machineValid ? 0 : machineErrorIndex]" >
            </div>

        </div>
        <div class="slot-button">
            <button v-if="!backTo1Allowed" class="btn btn-danger" @click="$root.logout()">Logout</button>
            <button v-else class="btn btn-danger" @click="$emit('backward')">{{$Jed.firstUpperTranslate('back', null)}}</button>
            
            <popover-alert effect="fade" placement="top" v-if="!$Behaviors.requestUpdateReference"
            :title="$Jed.firstUpperTranslate('are you sure?', null)" 
            :content="$Jed.firstUpperTranslate('do you want to proceed without applying any validity filter?', null)" 
            :ok="load" :ok_text="$Jed.firstUpperTranslate('yes', null)" :no_text="$Jed.firstUpperTranslate('no', null)"
            :popoverStyle="{ right:'10px', 'max-width': '200px', width: '100%', 'font-size': 'small', height: 'max-content', bottom: '60px'}" 
            :arrowStyle="{left:'75%'}" :textStyle="{color: '#222'}" classes="autoleft autotop" >
               <button class="btn btn-default" style="width: auto;">{{$Jed.firstUpperTranslate('skip', null)}}</button>
            </popover-alert>
            <button class="btn btn-success" @click="forward" :disabled="empty || forwarding">{{$Jed.firstUpperTranslate('load', null)}}</button>
        </div>
    </div> 
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {it, en, es, fr, de, ru} from 'vuejs-datepicker/dist/locale'
import PopoverAlert from "../../dynamic/popoverWrapper/Popover.vue";
import { eventBus } from "../../../eventbus.js";

export default {
  props: {
    catalogo: String,
    modello: String,
    backTo1Allowed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Datepicker,
    PopoverAlert
  },
  created: function(){
    //imposto la lingua per il datepicker
    if(this.$root.lang.lang == 'it'){
        this.datePickLang = it;
    }else if(this.$root.lang.lang == 'en'){
        this.datePickLang = en;
    }else if(this.$root.lang.lang == 'fr'){
        this.datePickLang = fr;
    }else if(this.$root.lang.lang == 'de'){
        this.datePickLang = de;
    }else if(this.$root.lang.lang == 'es'){
        this.datePickLang = es;
    }else if(this.$root.lang.lang == 'ru'){
        this.datePickLang = ru;
    }
  },
  mounted: function() {
    if (this.reference == "date" && this.$Behaviors.presetProductionDate) {
      this.date = new Date();
      eventBus.$emit('date', this.date)
    }
  },
  data: function() {
    return {
      matricola: null,
      machineValid: true,
      machineErrorIndex: 1,
      machinePlaceholder: [
        this.$Jed.firstUpperTranslate("insert %1$s to identify", null, {
          key: "machine ID"
        }),
        this.$Jed.firstUpperTranslate("incorrect %1$s format", null, {
          key: "machine ID"
        }),
        this.$Jed.firstUpperTranslate("%1$s not found in selected catalog", null, {
          key: "machine ID"
        }),
        this.$Jed.firstUpperTranslate("%1$s reference not found", null, {
          key: "machine ID"
        })
      ],

      date: null,
      reference: this.$Behaviors.updatesReference,
      forwarding: false,
      datePickLang: null
    };
  },
  computed: {
    empty: function() {
      return (
        (this.reference == "date" && this.date == null) ||
        (this.reference == "serial" && this.matricola == null)
      );
    }
  },
  methods: {
    async forward(){
      this.machineErrorIndex = 1;
      if (this.reference == "serial") {
        if(this.$Behaviors.machineIdValidationExp && this.$Behaviors.machineIdValidationExp != ""){
          try {
            var reg_matricola = new RegExp(this.$Behaviors.machineIdValidationExp);
            this.machineValid = reg_matricola.test(this.matricola);
          } catch (err) {
            console.log("Parsing Machine ID RegExp");
            console.log(err);
            this.machineValid = false;
          }
        }
        if (this.machineValid) {
          /*
          var machines_c = this.$root.dbRegistry.getCollection('machines'),
            nodes_c = this.$root.dbModels.getCollection('nodes'),
            // 1 controllo prima che sia presente nella collezione delle matricole del registry
            machine = machines_c.find({"id": this.matricola}),
            node;
          */

          // se la matricola ha un formato valido
          var nodes_c = this.$root.dbModels.getCollection('nodes'),
            node;
          console.log("waiting machine")
          this.forwarding = true;
          var machine = await this.$root.fetchRegistryData("machines", "GetMachines", "recordset", {"id": this.machineValue})
          this.forwarding = false;
          console.log("machine")
          //

          if(machine && machine.length > 0){
            machine = machine[0]
            // 2 in seguito controllo che ci sia un nodo relativo al prodotto di matricola nella collezione dei modelli (!associato al catalofgo selezionato!)
            node = nodes_c.find({"sid": machine.pid, "cac": Number(this.catalogo)});
            if(node && node.length > 0){
              node = node[0]; // se ci sono più categorie associate al modello (possibile?) prendo la prima, il risultato non cambia in ogni caso
              this.$root.validity = this.matricola;
              // se ogni ricerca va a buon fine, carico il modello associato alla matricola, passando anche il riferimento alla categoria (necessaria per caricare il modello come root)
              this.load(node.fid, node.sid);
            } else {
              this.matricola = null;
              this.machineValid = false;
              //flag che segnala di segnalare l'errore con una stringa diversa nell'array di machinePlaceholder
              this.machineErrorIndex = 2;
            }
          } else {
            this.matricola = null;
            this.machineValid = false;
            this.machineErrorIndex = 3;
          }
        } else {
          this.matricola = null;
          this.machineValid = false;
          this.machineErrorIndex = 1;
        }
      } else {
        try {
          // var d = Date.parse(this.date);
          // this.$root.validity = d;
          this.$root.validity = this.date;
          console.log("SET VALIDITY")
          console.log(this.date);
          this.load();
        } catch (err) {
          console.log("Err parsing validity date");
          console.log(err);
        }
      }
    },
    load: function(c, m) {
      eventBus.$emit('closePurchasePopup', null)
      var parameters = {};
      parameters.functionName = "load";
      if (this.matricola != null && c && m) {
        parameters.override = {modello: m, categoria: c}
      }

      this.$emit("forward", parameters);
    },
    backward: function() {
      var parameters = {};
      parameters.step = this.matricola != null ? 6 : 5;
      this.$emit("forward", parameters);
    }
  }
};
</script>
<style>
#step_component_wrapper .vdp-datepicker__calendar {
  position: relative !important;
  width: auto;
}
#step_component_wrapper .vdp-datepicker__calendar .selected {
  color: white;
  background-color: #337ab7 !important;
}
#step_component_wrapper .vdp-datepicker input {
  text-align: center;
}
</style>
<style scoped>
.error_highlight {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
div.input-group > span {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
div.input-group > input {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/loader/steps/ImpostazioneCompatibilità.vue?3c056d38